import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { translate } from "../../config";
import { useMessages } from "../../context/MessagesContext";
import { groupByFirstLetter, Item } from "../../model";
import Badge from "../Badge/Badge";
import { useSearchParams } from "react-router-dom";
import Flag from "../Flag/Flag";
import HeadlineGroup from "../HeadlineGroup/HeadlineGroup";
import HeroHeadline from "../HeroHeadline/HeroHeadline";
import Link from "../Link/Link";
import Search from "../Search/Search";
import SetTitle from "../SetTitle";
import { useRadarConfiguration } from "../../hooks/UseRadarConfiguration";
import { dataConfigTransform } from "../../contentful/transformers/config/config";
import { dataRadarTransform } from "../../contentful/transformers/radar/radar";

const containsSearchTerm = (text = "", term = "") => {
  // TODO search refinement
  return (
    text.trim().toLocaleLowerCase().indexOf(term.trim().toLocaleLowerCase()) !==
    -1
  );
};

export default function PageOverview() {
  const { radarName } = useParams();
  const { data: radarData } = useRadarConfiguration(radarName);
  const items = radarData && dataRadarTransform(radarData).items;
  const config = radarData && dataConfigTransform(radarData);
  const rings = config?.rings;

  const [ring, setRing] = useState<string | "all">("all");
  const [search, setSearch] = useState("");
  const { pageOverview } = useMessages();
  const title = pageOverview?.title || "Technologies Overview";

  let [searchParams, setSearchParams] = useSearchParams();
  console.log(searchParams);

  useEffect(() => {
    setSearch(searchParams.get("search") || "");
  }, [searchParams]);

  const handleSearchChange = (value: string) => {
    setSearchParams({ search: value });
  };

  const handleRingClick = (ring: string) => () => {
    setRing(ring);
  };

  const isRingActive = (ringName: string) => ring === ringName;

  const itemMatchesRing = (item: Item) => ring === "all" || item.ring === ring;

  const itemMatchesSearch = (item: Item) => {
    return (
      search.trim() === "" ||
      containsSearchTerm(item.title, search) ||
      containsSearchTerm(item.body, search) ||
      containsSearchTerm(item.info, search)
    );
  };

  const isItemVisible = (item: Item) =>
    itemMatchesRing(item) && itemMatchesSearch(item);

  const getFilteredAndGroupedItems = () => {
    const groups = groupByFirstLetter(items || []);
    const groupsFiltered = groups.map((group) => ({
      ...group,
      items: group.items.filter(isItemVisible),
    }));
    const nonEmptyGroups = groupsFiltered.filter(
      (group) => group.items.length > 0
    );
    return nonEmptyGroups;
  };

  const groups = getFilteredAndGroupedItems();
  

  return (
    <>
      {config && rings?.length && (
        <>
          <SetTitle title={title} />
          <HeadlineGroup>
            <HeroHeadline>{title}</HeroHeadline>
          </HeadlineGroup>
          <div className="filter">
            <div className="split split--filter">
              <div className="split__left">
                <Search onChange={handleSearchChange} value={search} />
              </div>
              <div className="split__right">
                <div className="nav">
                  {["all", ...rings].map((ringName) => (
                    <div className="nav__item" key={ringName}>
                      <Badge
                        big
                        onClick={handleRingClick(ringName)}
                        type={isRingActive(ringName) ? ringName : "empty"}
                      >
                        {ringName}
                      </Badge>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="letter-index">
            {groups.map(({ letter, items }) => (
              <div key={letter} className="letter-index__group">
                <div className="letter-index__letter">{letter}</div>
                <div className="letter-index__items">
                  <div className="item-list">
                    <div className="item-list__list">
                      {items.map((item) => (
                        <Link
                          key={item.name}
                          className="item item--no-leading-border item--no-trailing-border"
                          pageName={`/${radarName}/${item.quadrant}/${item.name}`}
                        >
                          <div className="item__title">
                            <span className="item__title__text">
                              {item.title}
                            </span>
                            <Flag item={item} />
                          </div>
                          <div className="item__subtitle">
                            <div>{translate(config, item.quadrant)}</div>
                            <div>
                              <Badge type={item.ring}>{item.ring}</Badge>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
